import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: '[--slide-size:70%] [--slide-spacing:12px] md:[--slide-size:50%] md:[--slide-spacing:20px] lg:[--slide-size:36%] xl:[--slide-size:30%] 2xl:[--slide-size:25%]',
    card: 'relative isolate flex min-h-[69.3vw] w-full flex-col p-4 pb-5 text-white md:min-h-[572px] md:px-8 md:pt-9 md:pb-6',
    bottom: 'justify-end',
    image: 'absolute inset-0 -z-1 size-full object-cover',
    title: 'text-[15px] leading-[1.2] font-medium uppercase md:text-2xl',
    text: 'mt-2 text-sm leading-[1.2] font-light md:text-xl',
    without:
      'flex items-center justify-center gap-3 font-bold uppercase md:mt-[-12px] md:mr-[18px] md:gap-[18px]',
    withoutMain:
      'border-r-2 pr-2.5 text-[40px] leading-[1.1] md:pr-3.5 md:text-[60px]',
    withoutDetails: 'text-[13px] leading-[1.3] md:text-base'
  },
  variants: {
    tone: {
      light: {
        card: 'text-white'
      },
      dark: {
        card: 'text-black'
      }
    }
  },
  defaultVariants: {
    tone: 'light'
  }
});
